import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "../../components/teams/tab/Tabs";
import TeamsTable from "../../components/teams/table/TeamsTable";
import ManageRoles from "../../components/teams/manage_roles/ManageRoles";
import { useRoleContext } from "../../../context/RolesContext";

const Teams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");

  const isManageMode = mode === "manage";
  const { resetContext } = useRoleContext();

  // Reset context when entering manage mode
  useEffect(() => {
    if (isManageMode) {
      resetContext();
    }
  }, [isManageMode, resetContext]);

  const exitManageMode = () => {
    const cleanParams = new URLSearchParams(location.search);
    cleanParams.delete("mode");
    navigate(`/dashboard/settings?${cleanParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <>
      {isManageMode ? (
        <section>
          <ManageRoles exitManageMode={exitManageMode} />
        </section>
      ) : (
        <section className="bg-white rounded-md flex flex-col gap-4 p-4">
          <section className="p-3">
            <Tabs />
          </section>
          <section>
            <TeamsTable />
          </section>
        </section>
      )}
    </>
  );
};

export default Teams;
